import React, { useEffect, useState } from 'react';
import { api } from '../api';

export function useAirline(flightNo, day) {
  const [info, setInfo] = useState(null);
  useEffect(() => {
    const v = (flightNo || '').trim();
    if (v.length < 3) { setInfo(null); return undefined; }
    const h = setTimeout(() => {
      api.get('/travel/flights/lookup', { params: { flight_no: v, date: day || '' } }).then((r) => setInfo(r.data)).catch(() => setInfo({ invalid: true }));
    }, 400);
    return () => clearTimeout(h);
  }, [flightNo, day]);
  return info;
}

export function FlightHint({ info, testid }) {
  if (!info) return null;
  if (info.invalid) return <p className="text-[11px] text-[#E37A72]" data-testid={testid}>Numero di volo non valido (es. AZ610)</p>;
  const live = info.live_available;
  return (
    <p className="text-[11px] text-[#8A8F97]" data-testid={testid}>
      {info.airline ? `Compagnia: ${info.airline}` : `Compagnia non riconosciuta (${info.code})`}
      {live ? (info.callsign ? ` · ritardi seguiti in tempo reale quando il volo è visibile (${info.source}, ADS-B)` : ' · ritardi non seguibili per questa compagnia (sigla radio diversa dal numero volo)') : ' · monitoraggio ritardi non attivo'}
    </p>
  );
}

export function ArrivalFields({ prefix, v, onChange, day, className, departure = false }) {
  const info = useAirline(v.flight_no, day);
  return (
    <>
      <label className="text-[11px] text-[#8A8F97] min-w-0">Ora di arrivo (locale)
        <input required type="time" value={v.arrival_time || ''} onChange={(e) => onChange({ ...v, arrival_time: e.target.value })} className={className} data-testid={`${prefix}-arrival-time`} /></label>
      <label className="text-[11px] text-[#8A8F97] min-w-0">Numero volo (se in aereo)
        <input value={v.flight_no || ''} onChange={(e) => onChange({ ...v, flight_no: e.target.value.toUpperCase() })} placeholder="es. AZ610" className={className} data-testid={`${prefix}-flight-no`} />
        <FlightHint info={info} testid={`${prefix}-flight-hint`} /></label>
      {departure && (v.flight_no || '').trim() && (
        <label className="text-[11px] text-[#8A8F97] min-w-0">Partenza del volo (ora italiana)
          <input required type="time" value={v.departure_time || ''} onChange={(e) => onChange({ ...v, departure_time: e.target.value })} className={className} data-testid={`${prefix}-departure-time`} /></label>
      )}
    </>
  );
}
